import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useEffect } from "react";
import Card from "react-bootstrap/Card";
import { Col, Row } from "react-bootstrap";
import SwitchCustom from "../Switches/Switch";
import { Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { setFormat } from "../../Redux/DownloadSlice/downloadSlice";
import { useDispatch } from "react-redux";
import type { RootState } from "../../Redux/store";

interface ImageTypeProps {
  downloadState: RootState["downloadSlice"];
}

const ImageType: React.FC<ImageTypeProps> = ({ downloadState }) => {
  const [selectedValue, setSelectedValue] = React.useState<string>(() => {
    const f = downloadState?.Format;
    if (f === 0) return "jpg";
    if (f === "png" || f === 2) return "png";
    return "jpg";
  });
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(downloadState?.Format === 0);

  const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    if (!event.target.checked) {
      setSelectedValue("jpg");
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!checked) {
      setSelectedValue(event.target.value);
    }
  };

  const dispatch = useDispatch();

  // Keep UI in sync when Redux is updated from GetSettings (async after modal open).
  useEffect(() => {
    const f = downloadState.Format;
    setChecked(f === 0);
    if (f === "png" || f === 2) setSelectedValue("png");
    else setSelectedValue("jpg");
  }, [downloadState.Format]);

  useEffect(() => {
    dispatch(setFormat(checked ? 0 : (selectedValue as "jpg" | "png")));
  }, [checked, selectedValue, dispatch]);

  const controlProps = (item: string) => ({
    checked: !checked && selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  return (
    <Card className="bg_grey">
      <Card.Header>
        <Col className="p-1 d-flex justify-content-between">
          <Row className="productSans text_15 d-flex justify-content-center align-items-center">
            {t("DownloadImage.Format")}
          </Row>
          <Row className="p-0 m-0">
            <FormGroup sx={{ p: 0, m: 0 }}>
              <FormControlLabel
                label=""
                control={
                  <SwitchCustom
                    checked={checked}
                    onChange={handleChangeSwitch}
                    sx={{ p: 0, m: 0 }}
                  />
                }
              />
            </FormGroup>
          </Row>
        </Col>
      </Card.Header>
      <Card.Body className="py-0">
        <Col className="p-1 d-flex justify-content-between align-items-center">
          <Row className="SF m-0 text_16 d-flex justify-content-center align-items-center">
            {t("DownloadImage.JPG")}
          </Row>
          <Row className="m-0 d-flex justify-content-center align-items-center">
            <Radio
              disabled={checked}
              {...controlProps("jpg")}
              sx={{
                "&.Mui-checked": {
                  color: "#F35B6A",
                },
              }}
            />
          </Row>
        </Col>

        <Col className="border-top p-1 d-flex justify-content-between align-items-center">
          <Row className="SF m-0 text_16  d-flex justify-content-center align-items-center">
            {t("DownloadImage.PNG")}
          </Row>
          <Row className="m-0 d-flex justify-content-center align-items-center">
            <Radio
              disabled={checked}
              {...controlProps("png")}
              sx={{
                "&.Mui-checked": {
                  color: "#F35B6A",
                },
              }}
            />
          </Row>
        </Col>
      </Card.Body>
    </Card>
  );
};

export default ImageType;
